import { styled } from "@pigment-css/react";

/** Body text for AI-generated summaries. `pre-wrap`: the model's line breaks are meaningful. */
export const SummaryText = styled("p")(({ theme }) => ({
  margin: 0,
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size[16],
  fontWeight: theme.fieldSalesTwo.font.weight[500],
  lineHeight: theme.fieldSalesTwo.font.lineHeight[148],
  color: theme.fieldSalesTwo.colors.neutral[900],
  whiteSpace: "pre-wrap",
}));
